export default __webpack_public_path__ + "static/media/NTB.edc14389.ico";